<script setup lang="ts">
import imgDoubleSquare from '@/assets/images/icon-double-square.png'
import type { SideBoxProps } from '@/types/appTypes'

const props = withDefaults(defineProps<SideBoxProps>(), {
  header: '',
  linkTo: null,
})
</script>

<template>
  <div class="c-sideHeading">
    <div class="c-sideHeading_title">
      <img
        v-bind:src="imgDoubleSquare"
        alt=""
        class="c-sideHeading_title_icon is-double"
      >
      <div
        class="c-sideHeading_title_text"
      >
        {{ header }}
      </div>
    </div>
    <div
      v-if="linkTo"
      class="c-sideHeading_more c-chevRightLink"
    >
      <ArrowLink
        v-bind:to="linkTo"
        label="もっとみる"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-sideHeading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 15px;
  font-family: var(--g_font_family_SawarabiGothic);
  font-size: 18px;

  &_title {
    display: flex;
    flex-grow: 1;
    align-items: center;

    &_icon {
      flex-shrink: 0;
      width: 16px;
      margin-right: 12px;
    }

    &_text {
      flex-grow: 1;
    }
  }

  &_more {
    flex-shrink: 0;
  }
}

.c-chevRightLink {
  display: inline-flex;
  position: relative;
  align-items: center;
  overflow: visible;
  color: var(--color_primary);
  font-size: 14px;
}
</style>
